import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const TriangleFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4474 10.0803C17.2277 10.3003 16.9672 10.4102 16.6662 10.4102H1.11117C0.81006 10.4102 0.549749 10.3003 0.329813 10.0803C0.109877 9.86016 0 9.59985 0 9.29892C0 8.99805 0.109877 8.73774 0.329813 8.51775L8.10735 0.740213C8.32753 0.520277 8.58784 0.410156 8.88871 0.410156C9.18958 0.410156 9.45013 0.520277 9.66988 0.740213L17.4474 8.51781C17.6671 8.73774 17.7774 8.99805 17.7774 9.29898C17.7774 9.59985 17.6671 9.86016 17.4474 10.0803Z"
        fill="currentColor"
      />
    </svg>
  )
})

TriangleFilled.displayName = 'TriangleFilled'
